module.exports = __webpack_public_path__ + "img/logo_CCIAA.6b50745b.png";